import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

import {
  getStudents,
  getStudentById,
  updateStudentStatus,
  removeStudent,
  updateStudent,
  updateStudentApplicationStatus,
  exportStudent,
  uploadStudentFiles,
  updateStudentFacultyAndFeeType,
} from "../repositories/studentRepository";

export const studentService = {
  getStudents: async ({
    currentPage,
    pageSize,
    dateFrom,
    dateTo,
    facultyTypes,
    studentStatuses,
    search,
  }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    const params = {
      "current-page": Number(pageNumber),
      "page-size": itemsPerPage,
    };
    if (dateFrom) params["date-from"] = dateFrom;
    if (dateTo) params["date-to"] = dateTo;
    if (Array.isArray(facultyTypes) && facultyTypes.length > 0) {
      params["faculty-types"] = facultyTypes;
    }
    if (Array.isArray(studentStatuses) && studentStatuses.length > 0) {
      params["student-statuses"] = studentStatuses;
    }
    if (search) params.search = search;

    return await getStudents(params);
  },

  getStudentById: async (id) => await getStudentById(id),

  updateStudent: async (id, body) => await updateStudent(id, body),

  uploadStudentFiles: async (formData) => await uploadStudentFiles(formData),

  updateStudentStatus: async (status, body) =>
    await updateStudentStatus(status, body),

  updateStudentApplicationStatus: async (id, status, body) => {
    let requestBody = {};

    if (body) {
      requestBody = body;
    }

    return await updateStudentApplicationStatus(id, status, requestBody);
  },

  removeStudent: async (id) => await removeStudent(id),

  exportStudent: async (body) => await exportStudent(body),

  updateStudentFacultyAndFeeType: async (id, body) =>
    await updateStudentFacultyAndFeeType(id, body),
};
